import gsap from 'gsap/all'
import ScrollTrigger from 'gsap/ScrollTrigger'

export default function() {
  const sections = document.querySelectorAll('.instagram-section')

  sections.forEach(section => {
    ScrollTrigger.batch(section.querySelectorAll('.instagram-post img'), {
      start: 'top bottom-=20%',
      end: 'top bottom-=20%',
      once: true,
      onEnter: batch => {
        gsap.to(batch, {
          scale: 1,
          opacity: 1,
          ease: 'basicEase',
          duration: 1,
          stagger: 0.15,
        })
      },
    })
  })
}
